export default async function GetOwnerPortfolio(ownerId = null, projectId = null) {
    let url = window.RealestateService + `/api/PaymentDetails/GetProjectWiseOwnerPaymentDetails`
    if (ownerId === null) {
        url = url;
    }
    else if(ownerId){
        url = url+`?ownerId=${ownerId}`;
    }
    if(projectId){
        url = url + `?projectId=${projectId}`;
    }
    let head = {
        "content-type": "application/json",
        "accept": "*/*"
    }
    let response = await fetch(url, {
        method: "GET",
        headers: head,
    }).then(res => res.json()).catch(res => res)

    return response
}